import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
  Button,
  Grid,
  SvgIcon,
  Typography,
} from '@material-ui/core';
import {
  PlusCircle as PlusCircleIcon,
} from 'react-feather';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import useStyles from './styles';
import BulkUploadModal from './BulkUploadModal';
import BulkUploadRolesModal from './BulkUploadRolesModal';

function Header({ className, onReload, ...rest }) {
  const classes = useStyles();
  const [openBulkUploadModal, setOpenBulkUploadModal] = useState(false);
  const [openBulkUploadRolesModal, setOpenBulkUploadRolesModal] = useState(false);

  return (
    <>
      <Grid
        className={clsx(classes.emptyRoot, className)}
        container
        justifyContent="space-between"
        spacing={3}
        {...rest}
      >
        <Grid item>
          <Typography
            variant="h3"
            color="textPrimary"
          >
            Roles de Proyecto
          </Typography>
        </Grid>
        <Grid item style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Button
            color="primary"
            variant="outlined"
            onClick={() => setOpenBulkUploadRolesModal(true)}
          >
            <CloudUploadIcon fontSize="small" style={{ marginRight: 8 }} />
            Carga Masiva Roles
          </Button>
          <Button
            color="primary"
            variant="outlined"
            onClick={() => setOpenBulkUploadModal(true)}
          >
            <CloudUploadIcon fontSize="small" style={{ marginRight: 8 }} />
            Carga Masiva Criterios
          </Button>
          <Button
            color="secondary"
            variant="contained"
            className={classes.action}
            href="/administracion/proyecto-roles/crear"
          >
            <SvgIcon
              fontSize="small"
              className={classes.actionIcon}
            >
              <PlusCircleIcon />
            </SvgIcon>
            Agregar Rol
          </Button>
        </Grid>
      </Grid>
      <BulkUploadRolesModal
        open={openBulkUploadRolesModal}
        onClose={() => setOpenBulkUploadRolesModal(false)}
        onSuccess={() => {
          if (onReload) onReload();
          setOpenBulkUploadRolesModal(false);
        }}
      />
      <BulkUploadModal
        open={openBulkUploadModal}
        onClose={() => setOpenBulkUploadModal(false)}
        onSuccess={() => {
          if (onReload) onReload();
          setOpenBulkUploadModal(false);
        }}
      />
    </>
  );
}

Header.propTypes = {
  className: PropTypes.string,
  onReload: PropTypes.func,
};

Header.defaultProps = {
  onReload: null,
};

export default Header;
